// 戴冠獣・道1の描き直し (2026-10-31・作者が完成までの道のり A＝近い6体を閉じる を選んだ。研究 = docs/research/2026-10-31-road1-art.md)。
//   吠えは 11-01 に b を入れたが、作者「はしゃいでるようにしかみえない・前のほうがマシ」で前の絵へ戻した。三連は 11-01 作者の答え (redraw) で描き直しを、配布版の既定にした (下の HOUND_ROAR_DEFAULT・HOUND_TRIPLE_ART_DEFAULT)。
//
// ?houndRoar=now|a|c: のしかかり・致命の「上を向いて溜める吠え」の絵を替える (既定＝前の houndPounce_rearup・now も同じ・絵は消さない)。
//   a＝立ち上がって前脚を曲げる・b＝立ち上がって爪を開く・c＝四つ足のまま首を上げる (外見カード「二足で立たない」に沿う)。
//   吠えの FX の口の位置は案ごとに測り直した値 (houndRoarMouth・hound_howl_fx.ts が読む)。
// ?houndTripleArt=now: 幕2の三連の爪と叩きつけを前の絵 (houndTriple_swipeFar・houndTriple_slam) へ戻す (既定＝描き直した2枚・絵は消さない)。
//   当たりは変えない。新しい絵は体が前後に長いので、大きさ (sprites.ts の 0.91・1.04) と横の位置 (下の offset) で
//   「後ろ足の踵が切り替えで 8px 以上跳ばない」と「当たりが打つ脚の先から 15px 以内」の両方に収めた (tests/hound_road1_1031.test.ts)。
import { BOSS_ATTACK_TIMELINES } from './boss_pose_timeline'
import type { SpriteKey } from './types'

export type HoundRoarArt = 'a' | 'b' | 'c'

/** 口の位置 = 体の中心から顔の向きへ高さの fwd・足から高さの up (今の絵は 0.22・1.45)。紫の口の中心を描画と同じ置き方で測った。 */
const ROAR_MOUTH: Record<HoundRoarArt, { up: number; fwd: number }> = {
  a: { up: 1.72, fwd: 0.32 },
  b: { up: 1.63, fwd: 0.21 },
  c: { up: 1.06, fwd: 0.67 },
}

let roarArt: HoundRoarArt | null = null
export function getHoundRoarArt(): HoundRoarArt | null { return roarArt }
export function houndRoarMouth(): { up: number; fwd: number } | null { return roarArt ? ROAR_MOUTH[roarArt] : null }

const roarKey = (v: HoundRoarArt): SpriteKey => `houndRoar_1031${v}`
const ROAR_KEYS = new Set<string>(['houndPounce_rearup', roarKey('a'), roarKey('b'), roarKey('c')])

/** 配布版の既定＝前の絵 (11-01 作者「はしゃいでるようにしかみえない・前のほうがマシだった」)。 */
export const HOUND_ROAR_DEFAULT: HoundRoarArt | null = null

export function setHoundRoarArt(v: HoundRoarArt | null): void {
  if (v === roarArt) return
  roarArt = v
  const to: SpriteKey = v ? roarKey(v) : 'houndPounce_rearup'
  for (const id of ['houndPounce', 'houndExecution']) {
    for (const key of BOSS_ATTACK_TIMELINES['dream-hound']![id] ?? []) if (ROAR_KEYS.has(key.image)) key.image = to
  }
}

setHoundRoarArt(HOUND_ROAR_DEFAULT)

// 三連: [技, 今の絵, 新しい絵, 新しい絵の横の位置]。今の絵の所は offset が無い (当たりの絵はずらさない) ので、戻す時は offset ごと消す。
const TRIPLE_SWAPS: Array<[string, SpriteKey, SpriteKey, number]> = [
  ['houndTriple2Claw', 'houndTriple_swipeFar', 'houndTriple_swipeFar_1031', 18],
  ['houndTriple2Fang', 'houndTriple_swipeFar', 'houndTriple_swipeFar_1031', 18],
  ['houndTriple2Slam', 'houndTriple_slam', 'houndTriple_slam_1031', 10],
]

let tripleArt = false
export function getHoundTripleArt1031(): boolean { return tripleArt }
export function setHoundTripleArt1031(on: boolean): void {
  if (on === tripleArt) return
  tripleArt = on
  for (const [id, now, art, x] of TRIPLE_SWAPS) {
    for (const key of BOSS_ATTACK_TIMELINES['dream-hound']![id] ?? []) {
      if (on && key.image === now) { key.image = art; key.offset = { x } }
      else if (!on && key.image === art) { key.image = now; delete key.offset }
    }
  }
}

/** 配布版の既定 (11-01 作者「triple = redraw」)。 */
export const HOUND_TRIPLE_ART_DEFAULT = true

setHoundTripleArt1031(HOUND_TRIPLE_ART_DEFAULT)
